/**
 * Clear Activities Utility
 * This utility ensures that no activities are shown by default for any user
 */

// Data key for activities
const ACTIVITIES_KEY = 'collegeActivities';

/**
 * Clear all activities and ensure empty state
 * @returns {object} Result of the operation
 */
export const clearAllActivities = () => {
  try {
    // Remove activities from localStorage
    localStorage.removeItem(ACTIVITIES_KEY);
    
    // Initialize with empty array
    localStorage.setItem(ACTIVITIES_KEY, JSON.stringify([]));
    
    // Dispatch event to notify all components
    window.dispatchEvent(new CustomEvent('collegeActivitiesUpdated', {
      detail: { activities: [] }
    }));
    
    console.log('✅ All activities cleared successfully');
    
    return {
      success: true,
      message: 'All activities cleared and reset to empty state'
    };
  } catch (error) {
    console.error('❌ Error clearing activities:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Check if activities exist
 * @returns {boolean} True if activities exist, false otherwise
 */
export const hasActivities = () => {
  try {
    const activities = JSON.parse(localStorage.getItem(ACTIVITIES_KEY)) || [];
    return activities.length > 0;
  } catch (error) {
    return false;
  }
};

/**
 * Get current activities count
 * @returns {number} Number of activities
 */
export const getActivitiesCount = () => {
  try {
    const activities = JSON.parse(localStorage.getItem(ACTIVITIES_KEY)) || [];
    return activities.length;
  } catch (error) {
    return 0;
  }
};

// Make functions available globally for easy access
if (typeof window !== 'undefined') {
  window.clearActivities = {
    clearAll: clearAllActivities,
    hasActivities,
    getCount: getActivitiesCount
  };
  
  console.log('🧹 Activity clearing utilities loaded!');
  console.log('Available functions:');
  console.log('  window.clearActivities.clearAll() - Clear all activities');
  console.log('  window.clearActivities.hasActivities() - Check if activities exist');
  console.log('  window.clearActivities.getCount() - Get activities count');
} 